import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_PRODUCT_SLIP_LIST_REQUEST,
  UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_REQUEST,
} from "./actionTypes";
import {
  getProductSlipListResponse,
  updateProductSlipStatusByProductSlipIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getProductSlipList({ payload: { filter } }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/ProductSlip/GetProductSlipsByParams",
      filter
    );
    yield put(getProductSlipListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductSlipStatusByProductSlipId({
  payload: { productSlipId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/ProductSlip/SetProductSlipStatus/" + productSlipId + "/" + status
    );
    yield put(updateProductSlipStatusByProductSlipIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchProductSlip() {
  yield takeEvery(GET_PRODUCT_SLIP_LIST_REQUEST, getProductSlipList);
  yield takeEvery(
    UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_REQUEST,
    updateProductSlipStatusByProductSlipId
  );
}

function* productSlipSaga() {
  yield all([fork(watchProductSlip)]);
}

export default productSlipSaga;
